<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M4 16C4 17.1046 4.89543 18 6 18H14C15.1046 18 16 17.1046 16 16V6L12 2H6C4.89543 2 4 2.89543 4 4V16ZM15 7L11 3V7H15ZM7 9H8.5L10 11L11.5 9H13L11 12L13 15H11.5L10 13L8.5 15H7L9 12L7 9Z"
  />
</svg>
